<template>
  <div class="subscription-info">
    <div class="current-level-info" v-if="haveActiveSubscription">
      <p>
        {{ $t('subscriptions.your_current_level', {'name': levelName, 'price': levelPrice, 'currency': levelCurrency, 'period': paymentPeriodTranslated}) }}
      </p>
      <p>
        {{ $t('subscriptions.available_at_this_level') }}<span v-for="(grant, index) in freeEffectGrants" :key="grant.class_id"> {{ grant.class_name }}: {{ grant.limit }} {{ $t(`sponsor.per_${grant.period}`) }}<span v-if="index < freeEffectGrants.length - 1">,</span><span v-else>.</span></span>
      </p>
    </div>
    <div class="expired-level-info" v-else>
      <p>
        {{ $t('subscriptions.your_expired_level', {'name': levelName, 'price': levelPrice, 'currency': levelCurrency, 'period': paymentPeriodTranslated}) }}
      </p>
    </div>
    <p v-if="paidTillFormatted">
      <span v-if="!haveActiveSubscription">
        {{ $t('subscriptions.is_expired') }}
      </span>
      <span v-else>
        {{ $t('subscriptions.paid_till') }}
      </span>
      {{ paidTillFormatted }}.
      <span v-if="downgradePlanned">
        {{ $t('subscriptions.next_level', {'name': nextLevel.name, 'price': nextLevel.price, 'currency': nextLevel.currency, 'period': $t(`subscriptions.period_${nextLevel.paymentPeriod}`), 'date': paidTillFormatted }) }}
      </span>
      <span v-else-if="isCanceled && haveActiveSubscription">
        {{ $t('subscriptions.you_have_canceled_this_subscription') }}
      </span>
    </p>
  </div>
</template>
<script>

import { Subscription } from '../store/models/Subscription';
import { SponsorshipLevel } from '../store/models/SponsorshipLevel';
import SubscriptionStatus from "../store/models/SubscriptionStatus";
import moment from "moment/moment";

export default {
  name: 'SubscriptionInfo',
  props: {
    subscription: {
      type: Subscription || null,
      default: null,
    },
    nextLevel: {
      type: SponsorshipLevel || null,
      default: null,
    },
  },
  computed: {
    levelName() {
      return this.subscription?.level.name;
    },
    haveActiveSubscription() {
      return this.subscription?.status === SubscriptionStatus.Paid;
    },
    downgradePlanned() {
      return this.$store.getters.downgradePlanned;
    },
    paidTill() {
      return this.subscription?.paidTill;
    },
    levelPrice() {
      return this.subscription?.level.price;
    },
    levelCurrency() {
      return this.subscription?.level.currency;
    },
    paymentPeriodTranslated() {
      return this.subscription? this.$t(`subscriptions.period_${this.subscription.level.paymentPeriod}`) : null;
    },
    freeEffectGrants() {
      return this.$store.getters.currentLevel.grants;
    },
    paidTillFormatted() {
      return this.subscription?.paidTill ? moment(this.subscription.paidTill).format(this.$t('date_time_format')).toString() : null;
    },
    isCanceled() {
      return this.subscription? !this.subscription.recurrent && this.subscription.nextRecurrentPayment == null && this.subscription.nextLevel == null : false;
    },
  },
};
</script>
<style lang="scss">
.subscription-info {
  max-width: 640px;
}
</style>
